import { useQuery } from "react-query";
import { systemMeasureQueryKeys } from "queries/constants";
import { getSystemMeasuresList } from "api/InsightsApi";
import { useToast } from "components/common/ui/toast/useToast";

export const useGetSystemMeasuresList = (
  orgId: string,
  params = {} as Record<string, any>,
  options?: any
) => {
  const { addErrorToast } = useToast();
  return useQuery(
    systemMeasureQueryKeys.list(orgId, params),
    () => getSystemMeasuresList(orgId, params),
    {
      onError: (e) =>
        addErrorToast(e, "Unable to load System Measures", {
          id: systemMeasureQueryKeys.list(orgId).join("::"),
        }),
      ...options,
    }
  );
};
